import { TerminationOfExistingContract } from "features/contracting/enums/terminationOfExistingContract";

export const isInvoiceUploadType = (
  processType: TerminationOfExistingContract
) => {
  const blacklistType: TerminationOfExistingContract[] = [
    "NoPlaceOfDeliveryNotConnected",
    "NoPlaceOfDeliveryNotExists",
  ];

  return !blacklistType.includes(processType);
};

export const isFilledProcessType = (
  processType: TerminationOfExistingContract
) => {
  return processType !== undefined && String(processType) !== "Undefined";
};

export const isFixedTermProlongation = (contractDurationType: string | undefined) => {
  return contractDurationType === "FixedTermProlongation";
};
